var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBagGrayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_741_6436)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_741_6436",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0V20H20V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_741_6436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 18.9578H6.66653C2.81653 18.9578 2.09986 17.1662 1.91653 15.4245L1.29153 8.7495C1.19986 7.87448 1.17486 6.58281 2.04153 5.61615C2.79153 4.78281 4.0332 4.38281 5.8332 4.38281H14.1665C15.9749 4.38281 17.2165 4.79115 17.9582 5.61615C18.8249 6.58281 18.7999 7.87448 18.7082 8.75784L18.0832 15.4162C17.8999 17.1662 17.1832 18.9578 13.3332 18.9578ZM5.8332 5.62448C4.42486 5.62448 3.4582 5.89948 2.96653 6.44948C2.5582 6.89948 2.42486 7.59115 2.5332 8.6245L3.1582 15.2995C3.29986 16.6162 3.6582 17.7078 6.66653 17.7078H13.3332C16.3332 17.7078 16.6999 16.6162 16.8415 15.2912L17.4665 8.63284C17.5749 7.59115 17.4415 6.89948 17.0332 6.44948C16.5415 5.89948 15.5749 5.62448 14.1665 5.62448H5.8332Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 5.62435C12.991 5.62435 12.7077 5.34102 12.7077 4.99935V4.33268C12.7077 2.84935 12.7077 2.29102 10.666 2.29102H9.33268C7.29102 2.29102 7.29102 2.84935 7.29102 4.33268V4.99935C7.29102 5.34102 7.00768 5.62435 6.66602 5.62435C6.32435 5.62435 6.04102 5.34102 6.04102 4.99935V4.33268C6.04102 2.86602 6.04102 1.04102 9.33268 1.04102H10.666C13.9577 1.04102 13.9577 2.86602 13.9577 4.33268V4.99935C13.9577 5.34102 13.6743 5.62435 13.3327 5.62435Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 13.9583C7.70898 13.9583 7.70898 12.5417 7.70898 11.6917V10.8333C7.70898 9.65833 7.99232 9.375 9.16732 9.375H10.834C12.009 9.375 12.2923 9.65833 12.2923 10.8333V11.6667C12.2923 12.5333 12.2923 13.9583 10.0007 13.9583ZM8.95898 10.625C8.95898 10.6917 8.95898 10.7667 8.95898 10.8333V11.6917C8.95898 12.55 8.95898 12.7083 10.0007 12.7083C11.0423 12.7083 11.0423 12.575 11.0423 11.6833V10.8333C11.0423 10.7667 11.0423 10.6917 11.0423 10.625C10.9757 10.625 10.9007 10.625 10.834 10.625H9.16732C9.10065 10.625 9.02565 10.625 8.95898 10.625Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6663 12.3069C11.3579 12.3069 11.0829 12.0736 11.0496 11.7569C11.0079 11.4152 11.2496 11.0986 11.5913 11.0569C13.7913 10.7819 15.8996 9.94857 17.6746 8.65691C17.9496 8.44857 18.3413 8.51524 18.5496 8.79857C18.7496 9.07357 18.6913 9.46524 18.4079 9.67357C16.4579 11.0902 14.1579 11.9986 11.7413 12.3069C11.7163 12.3069 11.6913 12.3069 11.6663 12.3069Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33394 12.3174C8.30894 12.3174 8.28394 12.3174 8.25894 12.3174C5.9756 12.0591 3.7506 11.2257 1.8256 9.90907C1.54227 9.7174 1.46727 9.32573 1.65894 9.0424C1.8506 8.75907 2.24227 8.68407 2.5256 8.87573C4.28394 10.0757 6.30894 10.8341 8.39228 11.0757C8.73394 11.1174 8.98394 11.4257 8.94228 11.7674C8.91728 12.0841 8.65061 12.3174 8.33394 12.3174Z",
    fill: "#5A5A5A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_741_6436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagGrayIcon);
export default __webpack_public_path__ + "static/media/bag_gray_icon.4e24e248207fc3f3e635b9559ce0954e.svg";
export { ForwardRef as ReactComponent };